import {RootState} from '../reducer/index'
import {_CALL_API} from '../../middleware/api'
import {route} from '../../../conf/routes'
import {_API} from './_Action'

export const uploadDocument = (document: any) => (dispatch, getState: () => RootState) => {
  const actions = _API('upload_document')
  return dispatch({
    [_CALL_API]: {
      types: [actions.REQUEST, actions.SUCCESS, actions.FAILURE],
      route: route.document.upload(document)
    }
  })
}

export const sendDocument = (data: any) => (dispatch, getState: () => RootState) => {
  const actions = _API('send_document')
  const enterpriseId = getState().accountInfo.enterpriseSelected.id
  return dispatch({
    [_CALL_API]: {
      types: [actions.REQUEST, actions.SUCCESS, actions.FAILURE],
      route: route.document.send(enterpriseId, data)
    }
  })
}


// WEBPACK FOOTER //
// ./src/core/redux/action/documentAction.ts